import React, { useRef, useState, useEffect } from 'react';
import { CalendarOutlined, SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { Button, Input, Space, Table } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { useSelector } from 'react-redux';
import DialogConfirme from '../dialog-confirm/dialog-confirm';
import DialogSave from '../dialog-save/dialog-save';
import firebase from '../../config/firebase';
import { Chip, Stack, Tooltip } from '@mui/material';
import PaymentModal from '../modal-salve-payment/modal-payment';
import paymentService from '../../service/payment.service';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModalFilter from '../../components/ModalFilter/ModalFilter.js';
import DatePickerMenu from '../dataPicker/dataPickerMenu';
import dayjs from 'dayjs';

require('firebase/auth')

const DataPaymentTableGeral = ({ cleanFilter, openFilter, onCleanFilterHandled, onOpenFilterHandled }) => {

  const db = firebase.firestore();

  const navigate = useNavigate();

  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [data, setData] = useState([]);
  const searchInput = useRef(null);

  const [openDialogYesOrNo, setOpenDialogYesOrNo] = useState();
  const [messageDialogYesOrNo, setMessageDialogYesOrNo] = useState();
  const [titleDialogYesOrNo, setTitleDialogYesOrNo] = useState();
  const [statusDialogYesOrNo, setStatusDialogYesOrNo] = useState();
  const [recordInput, setRecordInput] = useState();

  const [openDialog, setOpenDialog] = useState();
  const [messageDialog, setMessageDialog] = useState();
  const [titleDialog, setTitleDialog] = useState();
  const [statusDialog, setStatusDialog] = useState();
  const [open, setOpen] = useState();
  const [selectDriver, setSelectedDriver] = useState();

  const [updatedData, setUpdatedData] = useState(null);
  const [loading, setLoading] = useState(true);
  const hasLoadedRef = useRef(false);
  const [columnFilters, setColumnFilters] = useState({});
  const [dateRange, setDateRange] = useState([]);
  const [sorterConfig, setSorterConfig] = useState({ columnKey: null, order: null });
  const storageKey = (uid, key) => `${uid}:${key}`;
  const [openModalFilter, setOpenModalFilter] = useState(false);

  const user = useSelector(state => state.user)

  const view = user?.permissoes?.payment?.isView || user?.permissoes?.payment?.visualizar ? true : false;

  useEffect(() => {

    fetchDriverNames();
  }, []);

  // ========================
  // localStorage filtros
  // ========================
  useEffect(() => {
    if (!user?.uid) return;

    try {
      const savedDateRange = localStorage.getItem(
        storageKey(user.uid, "paymentDateRangeFilter"),
      );
      const savedColumnFilters = localStorage.getItem(
        storageKey(user.uid, "paymentColumnFilters"),
      );
      const savedSorter = localStorage.getItem(
        storageKey(user.uid, "paymentTableSorter"),
      );

      if (savedDateRange) {
        const parsedDateRange = JSON.parse(savedDateRange);
        const normalizedDateRange =
          Array.isArray(parsedDateRange) && parsedDateRange.length === 2
            ? parsedDateRange.map((d) => parseToDayjs(d))
            : [];

        setDateRange(normalizedDateRange);
        setSearchedColumn("dateFirstDelivery");
      } else {
        setDateRange([]);
      }

      // Carrega os filtros de coluna
      if (savedColumnFilters) {
        const parsedFilters = JSON.parse(savedColumnFilters);
        if (parsedFilters && typeof parsedFilters === "object") {
          const { dateFirstDelivery, ...filtersWithoutDate } = parsedFilters;
          setColumnFilters(filtersWithoutDate);
        } else {
          setColumnFilters({});
        }
      } else {
        setColumnFilters({});
      }

      if (savedSorter) {
        const parsedSorter = JSON.parse(savedSorter);
        if (
          parsedSorter &&
          typeof parsedSorter === "object" &&
          typeof parsedSorter.columnKey === "string" &&
          (parsedSorter.order === "ascend" || parsedSorter.order === "descend")
        ) {
          setSorterConfig({
            columnKey: parsedSorter.columnKey,
            order: parsedSorter.order,
          });
        } else {
          setSorterConfig({ columnKey: null, order: null });
        }
      } else {
        setSorterConfig({ columnKey: null, order: null });
      }

    } catch (error) {
      console.error("Erro ao carregar filtros do localStorage:", error);
      setDateRange([]);
      setColumnFilters({});
      setSorterConfig({ columnKey: null, order: null });
    }

    hasLoadedRef.current = true;
  }, [user?.uid]);

  useEffect(() => {
    if (!hasLoadedRef.current) return;
    if (!user?.uid) return;

    const hasActiveColumnFilters = Object.values(columnFilters || {}).some(
      (filterValue) => Array.isArray(filterValue) ? filterValue.length > 0 : Boolean(filterValue),
    );

    if (hasActiveColumnFilters) {
      localStorage.setItem(
        storageKey(user.uid, "paymentColumnFilters"),
        JSON.stringify(columnFilters),
      );
    } else {
      localStorage.removeItem(storageKey(user.uid, "paymentColumnFilters"));
    }

    if (sorterConfig?.columnKey && sorterConfig?.order) {
      localStorage.setItem(
        storageKey(user.uid, "paymentTableSorter"),
        JSON.stringify(sorterConfig),
      );
    } else {
      localStorage.removeItem(storageKey(user.uid, "paymentTableSorter"));
    }
    if (dateRange && dateRange.length === 2) {
      localStorage.setItem(
        storageKey(user.uid, "paymentDateRangeFilter"),
        JSON.stringify(dateRange),
      );
    } else {
      localStorage.removeItem(storageKey(user.uid, "paymentDateRangeFilter"));
    }
  }, [user?.uid, dateRange, columnFilters, sorterConfig]);

  // ========================
  // Limpar filtros via prop externa
  // ========================
  useEffect(() => {
    if (cleanFilter) {
      setColumnFilters({});
      setDateRange([]);
      setSearchText("");
      setSearchedColumn("");
      setSorterConfig({ columnKey: null, order: null });
      if (user?.uid) {
        localStorage.removeItem(storageKey(user.uid, "paymentDateRangeFilter"));
        localStorage.removeItem(storageKey(user.uid, "paymentColumnFilters"));
        localStorage.removeItem(storageKey(user.uid, "paymentTableSorter"));
      }
      if (onCleanFilterHandled) {
        onCleanFilterHandled();
      }
    }
  }, [cleanFilter, user?.uid, onCleanFilterHandled]);

  // ========================
  // Abrir modal de filtros salvos via prop externa
  // ========================
  useEffect(() => {
    if (openFilter) {
      setOpenModalFilter(true);
      if (onOpenFilterHandled) {
        onOpenFilterHandled();
      }
    }
  }, [openFilter, onOpenFilterHandled]);
  
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
    setColumnFilters((prev) => ({
      ...prev,
      [dataIndex]: selectedKeys?.length ? selectedKeys : null,
    }));
  };

  const handleDateRangeChange = (dates) => {
    setDateRange(dates ? [dates[0], dates[1]] : []);
  };

  const handleSearchDate = (confirm) => {
    confirm();
    setSearchText('');
    setSearchedColumn('dateFirstDelivery');
  };

  const handleResetDate = (clearFilters) => {
    clearFilters();
    setDateRange([]);
  };

  function toPascalCase(str) {
    if (!str) return "";
    return str
      .toLowerCase()
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  const paymentModalFilterColumns = [
    { key: "dateFirstDelivery", label: "Data do Carregamento", type: "date" },
    { key: "driver", label: "Motorista", type: "text" },
    { key: "order", label: "Frete", type: "text" },
    { key: "origem", label: "Origem", type: "text" },
    { key: "destino", label: "Destino", type: "text" },
    { key: "value", label: "Valor do Frete", type: "number" },
    { key: "status", label: "Status", type: "select" },
  ];

  const paymentStatusOptions = [
    { value: "cancelado", label: "Cancelado" },
    { value: "bloqueado", label: "Bloqueado" },
    { value: "pendente liberação", label: "Pendente Liberação" },
    { value: "solicitar pagamento", label: "Solicitar Pagamento" },
    { value: "em aberto", label: "Em Aberto" },
    { value: "baixa parcial", label: "Baixa Parcial" },
    { value: "pago", label: "Pago" },
  ];

  const fetchDriverNames = async () => {
    setLoading(true);
    try {
      const data = await paymentService.getAll();

      if (!data || data.length === 0) return;

      // ✅ filtro condicional com base no uidShipper
      let filteredData = [];
      if ( user.viewALL ) {

        filteredData = data;
      } else {
        if (user?.uidShipperAffiliates && Array.isArray(user.uidShipperAffiliates)) {
          const affiliateUids = Array.isArray(user?.uidShipperAffiliates) ? user.uidShipperAffiliates : [];
          const primaryUid = user?.uidShipper ? [user.uidShipper] : [];
          const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));

          if (uids.length > 1) {
            filteredData = data.filter(
              (item) => uids.uidShipper.includes(item.uidShipper)
            );
          }
          else {
            filteredData = data.filter(
              (item) => item.uidShipper === user?.uidShipper
            );
          }
        }
        else {
          filteredData = data.filter(
            (item) => item.uidShipper === user?.uidShipper
          );
        }
      }

      setData(filteredData);

      // Busca nomes de motoristas
      const driverPromises = filteredData.map(async (item) => {
        if (!item.driver) return item;

        const driverRef = db.collection("drivers_users").doc(item.driver);
        const driverSnap = await driverRef.get();

        if (driverSnap.exists) {
          return {
            ...item,
            driver: driverSnap.data().name,
            driverID: driverSnap.data().uid,
          };
        } else {
          return item;
        }
      });

      const updatedList = await Promise.all(driverPromises);

      // Agrupando por idFreight
      const groupedFreights = updatedList.reduce((acc, curr) => {
        const { idFreight } = curr;
        if (!acc[idFreight]) {
          acc[idFreight] = { idFreight, items: [] };
        }
        acc[idFreight].items.push(curr);
        return acc;
      }, {});

      const finalGroupedList = await Promise.all(
        Object.values(groupedFreights).map(async (group) => {
          // Buscar o frete no banco pelo idFreight
          const freightDoc = await db.collection("freight").doc(group.idFreight).get();

          if (freightDoc.exists) {
            const freightData = freightDoc.data();
            return {
              ...group,
              origem: freightData.firstDelivery?.city || null,
              origemState: freightData.firstDelivery?.uf || null,
              destino: freightData.lastDelivery?.city || null,
              destinoState: freightData.lastDelivery?.uf || null,
              history: freightData.history || null,
              dateFirstDelivery: freightData.firstDelivery?.dateColeta || null,
            };
          } else {
            return {
              ...group,
              origem: null,
              origemState: null,
              destino: null,
              destinoState: null,
              history: null,
              dateFirstDelivery: null,
            };
          }
        })
      );

      setUpdatedData(finalGroupedList);
      setLoading(false);
    } catch (error) {
      console.error("Erro ao buscar motoristas:", error);
      setLoading(false);
    }
  };

  const handleReset = (clearFilters, dataIndex) => {
    clearFilters();
    setSearchText('');
    setColumnFilters((prev) => {
      const nextFilters = { ...prev };
      delete nextFilters[dataIndex];
      return nextFilters;
    });
  };

  const deleteOcorrence = async () => {

    try {
      // console.log(recordInput)
      await paymentService.deleteDetalhes(recordInput);
      await fetchDriverNames();
    }
    catch (error) {
      console.error(error);
    }
    finally {
      setOpenDialogYesOrNo(false);
    }

  }

  const handleDialogCloseYesOrNo = () => {
    setOpenDialogYesOrNo(false);
  };

  const handleApplyCustomFilter = (filter) => {
    // Limpar filtros existentes antes de aplicar o novo
    const newFilters = {};
    let newDateRange = [];

    // Processar cada condição do filtro
    if (filter.conditions && filter.conditions.length > 0) {
      filter.conditions.forEach(condition => {
        const { column, operator, value } = condition;

        if (!column) return;

        // Status em formato multi-select para a coluna atual da tabela
        if (column === 'status') {
          if (operator === 'in' && Array.isArray(value) && value.length > 0) {
            newFilters[column] = value;
          } 
          else if (operator === 'equals' && value) {
            newFilters[column] = Array.isArray(value) ? value : [value];
          }
        }
        else if (column === 'dateFirstDelivery') {
          if (operator === 'between' && value && Array.isArray(value) && value.length === 2) {
            const startDate = typeof value[0] === 'string' ? dayjs(value[0]) : value[0];
            const endDate = typeof value[1] === 'string' ? dayjs(value[1]) : value[1];
            newDateRange = [startDate, endDate];
          }
          else if (operator === 'equals' && value) {
            const date = typeof value === 'string' ? dayjs(value) : value;
            newDateRange = [date, date];
          }
          else if (operator === 'after' && value) {
            const date = typeof value === 'string' ? dayjs(value) : value;
            newDateRange = [date, null];
          }
          else if (operator === 'before' && value) {
            const date = typeof value === 'string' ? dayjs(value) : value;
            newDateRange = [null, date];
          }
          else if (value) {
            const date = typeof value === 'string' ? dayjs(value) : value;
            newDateRange = [date, date];
          }
        }
        // Coluna numérica da tabela usa busca textual no filtro nativo (contains)
        else if (column === 'value' && value !== undefined && value !== null && value !== '') {
          newFilters[column] = [String(value)];
        }
        // Colunas textuais da tabela
        else {
          if (
            (operator === 'contains' ||
              operator === 'equals' ||
              operator === 'startsWith' ||
              operator === 'endsWith') &&
            value !== undefined &&
            value !== null &&
            value !== ''
          ) {
            newFilters[column] = [String(value)];
          }
        }
      });
    }

    setDateRange(newDateRange);
    setColumnFilters(newFilters);
  };

  const deleteEmb = (record) => {

    setRecordInput(record)
    setOpenDialogYesOrNo(true);
    setStatusDialogYesOrNo('error')
    setTitleDialogYesOrNo("Deletar ocorrência ")
    setMessageDialogYesOrNo("Tem certeza que deseja deletar a ocorrência " + record.name  + " ? ")

  };

  const handleEditClick = (record, view) => {
    navigate("/listPaymentDetail", { state: { record, viewOnly:view }});
  };

  const handleDialogClose = () => {
    setOpenDialog(false); 
    setOpenDialogYesOrNo(false);
  };

  const normalizeSearchText = (input = "") => (
    String(input)
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/\s*-\s*/g, "-")
      .replace(/\s+/g, " ")
      .trim()
  );

  const parseToDayjs = (value) => {
    if (!value) return null;

    if (dayjs.isDayjs(value)) {
      return value.isValid() ? value : null;
    }

    if (value instanceof Date || typeof value === "string" || typeof value === "number") {
      const parsed = dayjs(value);
      return parsed.isValid() ? parsed : null;
    }

    if (typeof value === "object") {
      if (value.$d) {
        const parsedFromInternalDate = dayjs(value.$d);
        if (parsedFromInternalDate.isValid()) return parsedFromInternalDate;
      }

      if (value.date) {
        const parsedFromDateProp = dayjs(value.date);
        if (parsedFromDateProp.isValid()) return parsedFromDateProp;
      }
    }

    return null;
  };

  const getDateOnly = (value) => {
    if (!value) return null;

    if (dayjs.isDayjs(value)) {
      if (!value.isValid()) return null;
      return new Date(value.year(), value.month(), value.date());
    }

    if (typeof value === 'string') {
      const normalized = value.trim();

      const isoMatch = normalized.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (isoMatch) {
        const [, year, month, day] = isoMatch;
        return new Date(Number(year), Number(month) - 1, Number(day));
      }

      const brMatch = normalized.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (brMatch) {
        const [, day, month, year] = brMatch;
        return new Date(Number(year), Number(month) - 1, Number(day));
      }

      return null;
    }

    if (typeof value === 'object' && typeof value.toDate === 'function') {
      const d = value.toDate();
      if (!(d instanceof Date) || Number.isNaN(d.getTime())) return null;
      return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    }

    if (value instanceof Date) {
      if (Number.isNaN(value.getTime())) return null;
      return new Date(value.getFullYear(), value.getMonth(), value.getDate());
    }

    return null;
  };

  const parseDateToTimestamp = (value) => {
    if (!value) return null;

    if (value instanceof Date && !Number.isNaN(value.getTime())) {
      return value.getTime();
    }

    const raw = String(value).trim();
    if (!raw) return null;

    const brMatch = raw.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (brMatch) {
      const [, day, month, year] = brMatch;
      const parsed = new Date(Number(year), Number(month) - 1, Number(day));
      return Number.isNaN(parsed.getTime()) ? null : parsed.getTime();
    }

    const isoDateOnly = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (isoDateOnly) {
      const [, year, month, day] = isoDateOnly;
      const parsed = new Date(Number(year), Number(month) - 1, Number(day));
      return Number.isNaN(parsed.getTime()) ? null : parsed.getTime();
    }

    const normalizedIso = raw.includes("T") ? raw : raw.replace(" ", "T");
    const parsed = new Date(normalizedIso);
    if (!Number.isNaN(parsed.getTime())) {
      return parsed.getTime();
    }

    return null;
  };

  const formatDatePtBr = (value) => {
    const ts = parseDateToTimestamp(value);
    if (!ts) return "-";
    return new Intl.DateTimeFormat("pt-BR").format(new Date(ts));
  };

  const doesColumnFilterMatch = (record, dataIndex, value) => {
    if (dataIndex === 'dateFirstDelivery') {
      const recordDateValue = record?.dateFirstDelivery;
      const recordTs = parseDateToTimestamp(recordDateValue);
      if (!recordTs) return false;

      if (typeof value === 'string') {
        try {
          const parsedValue = JSON.parse(value);
          if (parsedValue?.type === 'date' && parsedValue?.operator) {
            const operator = parsedValue.operator;

            if (operator === 'between' && Array.isArray(parsedValue.value)) {
              const [start, end] = parsedValue.value;
              const startTs = parseDateToTimestamp(start);
              const endTs = parseDateToTimestamp(end);
              if (!startTs || !endTs) return false;
              return recordTs >= startTs && recordTs <= endTs;
            }

            const filterTs = parseDateToTimestamp(parsedValue.value);
            if (!filterTs) return false;

            if (operator === 'equals') {
              return formatDatePtBr(recordDateValue) === formatDatePtBr(parsedValue.value);
            }
            if (operator === 'before') {
              return recordTs < filterTs;
            }
            if (operator === 'after') {
              return recordTs > filterTs;
            }
          }
        } catch (_) {
          // Filtro manual da coluna (texto) cai aqui e segue como busca textual.
        }

        const queryNorm = normalizeSearchText(value);
        const brDateNorm = normalizeSearchText(formatDatePtBr(recordDateValue));
        const rawDateNorm = normalizeSearchText(recordDateValue);
        return brDateNorm.includes(queryNorm) || rawDateNorm.includes(queryNorm);
      }

      return false;
    }

    if (dataIndex === 'driver') {
      const item = record.items?.find(item => item.driver);
      const driverName = item?.driver?.toLowerCase() || '';
      return driverName.includes(String(value).toLowerCase());
    }

    if (dataIndex === 'order') {
      const order = record.items?.[0]?.order?.toString() || '';
      return order.includes(String(value));
    }

    if (dataIndex === 'value') {
      const totalValue = record.items?.reduce((sum, item) => sum + (item.value || 0), 0) || 0;
      return totalValue.toFixed(2).toString().includes(String(value));
    }

    if (dataIndex === 'origem' || dataIndex === 'destino') {
      const city = dataIndex === 'origem' ? record?.origem : record?.destino;
      const uf = dataIndex === 'origem' ? record?.origemState : record?.destinoState;

      const query = normalizeSearchText(value);
      const cityNorm = normalizeSearchText(city);
      const ufNorm = normalizeSearchText(uf);
      const cityUfNorm = normalizeSearchText([city, uf].filter(Boolean).join(" - "));

      return (
        cityNorm.includes(query) ||
        ufNorm.includes(query) ||
        cityUfNorm.includes(query)
      );
    }

    if (typeof value === 'string') {
      return record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase());
    }

    return record[dataIndex] === value;
  };

  const getColumnSearchProps = (dataIndex) => ({
    filteredValue: columnFilters[dataIndex] || null,
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters, dataIndex)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),

    onFilter: (value, record) => doesColumnFilterMatch(record, dataIndex, value),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },

    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const getColumnSearchPropsDate = () => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <DatePickerMenu
          value={dateRange}
          onChange={(dates) => {
            handleDateRangeChange(dates);
            setSelectedKeys(dates ? [dates] : []);
          }}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearchDate(confirm)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleResetDate(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reiniciar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <CalendarOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
    ),
    onFilter: (_, record) => {
      if (!dateRange || dateRange.length === 0) return true;

      const [startDate, endDate] = dateRange;
      const current = getDateOnly(record?.dateFirstDelivery);
      if (!current) return false;

      const start = startDate ? getDateOnly(startDate) : null;
      const end = endDate ? getDateOnly(endDate) : null;

      if (start && end && start.getTime() === end.getTime()) {
        return current.getTime() === start.getTime();
      }

      if (start && !end) {
        return current.getTime() >= start.getTime();
      }

      if (!start && end) {
        return current.getTime() <= end.getTime();
      }

      if (start && end) {
        return current.getTime() >= start.getTime() && current.getTime() <= end.getTime();
      }

      return true;
    },
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
  });

  function getStatusFromUpdatedData(record) {
  
    const hasCancel = record.some(item => item.status?.toLowerCase() === "cancelado");
    const allPaid = record.every(item => item.status?.toLowerCase() === "pago");
    const hasPaid = record.some(item => item.status?.toLowerCase() === "pago");
    const hasSoli = record.some(item => item.status?.toLowerCase() === "solicitar pagamento");
    const hasPendent = record.some(item => item.status?.toLowerCase() === "pendente");
    const allBloqued = record.every(item => item.status?.toLowerCase() === "bloqueado");

    if (hasCancel) return "cancelado";
    if (allPaid) return "pago";
    if (hasSoli) return "solicitar pagamento";
    if (hasPendent) return "pendente liberação";
    if (allBloqued) return "bloqueado";
    if (hasPaid) return "baixa parcial";

    return "em aberto";
  }

  function renderStatusColor(record) {
    const status = getStatusFromUpdatedData(record.items);

    const chipStyle = {
      minWidth: '100px',
      maxWidth: '150px',
      borderRadius: '10px',
    };

    const commonChip = (label, color, customSx = {}) => (
      <Stack direction="row" spacing={1}>
        <Chip label={label} color={color} style={chipStyle} sx={customSx} />
      </Stack>
    );

    switch (status) {
      case "pago":
        return commonChip(toPascalCase(status), "success");
    
      case "baixa parcial":
        return commonChip(toPascalCase(status), "primary");
    
      case "em aberto":
        return commonChip(toPascalCase(status), "warning");
    
      case "pendente liberação":
        return commonChip(toPascalCase(status), "default", {
          backgroundColor: "#d4af37",
          color: "#1f1f1f",
        });
    
      case "solicitar pagamento":
        return commonChip(toPascalCase(status), "default", {
          backgroundColor: "#7b1fa2",
          color: "#fff",
        });
    
      case "cancelado":
        return commonChip(toPascalCase(status), "error");
    
      default:
        return commonChip(toPascalCase(status), "default");
    }
  }

  const getStatusSortWeight = (status) => {
    const statusWeight = {
      "cancelado": 1,
      "bloqueado": 2,
      "pendente liberação": 3,
      "solicitar pagamento": 4,
      "em aberto": 5,
      "baixa parcial": 6,
      "pago": 7,
    };

    return statusWeight[status] ?? 99;
  };

  const getDataFilteredByNonStatusFilters = () => {
    let baseData = updatedData || [];

    if (dateRange && dateRange.length > 0) {
      const [startDate, endDate] = dateRange;
      baseData = baseData.filter((record) => {
        const current = getDateOnly(record?.dateFirstDelivery);
        if (!current) return false;

        const start = startDate ? getDateOnly(startDate) : null;
        const end = endDate ? getDateOnly(endDate) : null;

        if (start && end && start.getTime() === end.getTime()) {
          return current.getTime() === start.getTime();
        }

        if (start && !end) {
          return current.getTime() >= start.getTime();
        }

        if (!start && end) {
          return current.getTime() <= end.getTime();
        }

        if (start && end) {
          return current.getTime() >= start.getTime() && current.getTime() <= end.getTime();
        }

        return true;
      });
    }

    const activeNonStatusFilters = Object.entries(columnFilters || {}).filter(
      ([key, values]) =>
        key !== 'status' && key !== 'dateFirstDelivery' && Array.isArray(values) && values.length > 0
    );

    if (!activeNonStatusFilters.length) {
      return baseData;
    }

    return baseData.filter((record) =>
      activeNonStatusFilters.every(([dataIndex, values]) =>
        values.some((value) => doesColumnFilterMatch(record, dataIndex, value))
      )
    );
  };

  const getUniqueStatusValues = () => {
    const dataFilteredByNonStatus = getDataFilteredByNonStatusFilters();
    const uniqueValues = new Set(
      dataFilteredByNonStatus.map((record) => getStatusFromUpdatedData(record?.items || []))
    );

    return Array.from(uniqueValues).sort((a, b) => {
      const diff = getStatusSortWeight(a) - getStatusSortWeight(b);
      return diff !== 0 ? diff : a.localeCompare(b);
    });
  };

  const getStatusFilterProps = () => ({
    filters: getUniqueStatusValues().map((status) => ({
      text: toPascalCase(status),
      value: status,
    })),
    filterSearch: true,
    filterMultiple: true,
    onFilter: (value, record) =>
      getStatusFromUpdatedData(record?.items || []) === value,
  });

  const columns = [
    {
      title: 'Data do Carregamento',
      dataIndex: 'dateFirstDelivery',
      key: 'dateFirstDelivery',
      width: '15%',
      filteredValue: dateRange && dateRange.length ? [dateRange] : null,
      filterDropdownProps: {
        placement: 'bottomLeft',
      },
      ...getColumnSearchPropsDate(),
      sortOrder: sorterConfig.columnKey === 'dateFirstDelivery' ? sorterConfig.order : null,
      sorter: (a, b) => {
        const dateA = parseDateToTimestamp(a?.dateFirstDelivery) || 0;
        const dateB = parseDateToTimestamp(b?.dateFirstDelivery) || 0;
        return dateA - dateB;
      },
      render: (_, record) => formatDatePtBr(record?.dateFirstDelivery),
    },
    {
      title: 'Motorista',
      dataIndex: 'driver',
      key: 'driver',
      width: '30%',
      ...getColumnSearchProps('driver'),
      sortOrder: sorterConfig.columnKey === 'driver' ? sorterConfig.order : null,
      sorter: (a, b) => {
        const driverA = a.items?.[0]?.driver || '';
        const driverB = b.items?.[0]?.driver || '';
        return driverA.localeCompare(driverB);
      },
      render: (_, record) => {
        if (!record.items || record.items.length === 0) return 'Sem motorista';

        const firstDriverItem = record.items.find(item => item.driver && item.driver.toLowerCase() !== "terceiros") || {};
        const { driver, driverID } = firstDriverItem;

        return driver ? (
          <Link to={`/driverList/${driverID || '#'}`}>
            <span>{driver}</span>
          </Link>
        ) : (
          <span>Motorista não encontrado</span>
        );
      }
    },
    {
      title: 'Frete',
      dataIndex: 'order',
      key: 'order',
      width: '15%',
      ...getColumnSearchProps('order'),
      sortOrder: sorterConfig.columnKey === 'order' ? sorterConfig.order : null,
      sorter: (a, b) => {
        const orderA = a?.items?.[0]?.order?.toString() || "";
        const orderB = b?.items?.[0]?.order?.toString() || "";
        return orderA.localeCompare(orderB);
      },
      render: (text, record) => {
        const idFreight = record.idFreight || "#";
        const order = record.items[0].order || "#";

        return (
          <Link to={`/freightCopy/${idFreight}`}>
            {order}
          </Link>
        );
      }
    },
    {
      title: 'Origem',
      dataIndex: 'origem',
      key: 'origem',
      width: '15%',
      ...getColumnSearchProps('origem'),
      sortOrder: sorterConfig.columnKey === 'origem' ? sorterConfig.order : null,
      sorter: (a, b) => (a?.origem || "").localeCompare(b?.origem || ""),
      render: (text, record) => {
        const city = record?.origem;
        const uf = record?.origemState;
        if (!city && !uf) return "#";
        if (!city) return uf;
        if (!uf) return city;
        return `${city} - ${uf}`;
      }
    },
    {
      title: 'Destino',
      dataIndex: 'destino',
      key: 'destino',
      width: '15%',
      ...getColumnSearchProps('destino'),
      sortOrder: sorterConfig.columnKey === 'destino' ? sorterConfig.order : null,
      sorter: (a, b) => (a.destino || "").localeCompare(b.destino || ""),
      render: (text, record) => {
        const city = record?.destino;
        const uf = record?.destinoState;
        if (!city && !uf) return "#";
        if (!city) return uf;
        if (!uf) return city;
        return `${city} - ${uf}`;
      }
    },
    {
      title: 'Valor do Frete',
      dataIndex: ['value'],
      key: 'value',
      align: 'center',
      width: '22%',
      ...getColumnSearchProps('value'),
      sortOrder: sorterConfig.columnKey === 'value' ? sorterConfig.order : null,
      render: (text, record) => {
        // Soma valores dentro de items (considerando desconto como subtração)
        const totalValue = record.items?.reduce((sum, item) => {
          const valor = (item.value || 0) + (item.valorAdicional || 0) - (item.desconto || 0);
          return sum + valor;
        }, 0) || 0;

        return totalValue.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        });
      },
      sorter: (a, b) => {
        const totalA = a.items?.reduce((sum, item) => sum + (item.value || 0), 0) || 0;
        const totalB = b.items?.reduce((sum, item) => sum + (item.value || 0), 0) || 0;

        return totalA - totalB;
      }
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "center",
      sortOrder: sorterConfig.columnKey === "status" ? sorterConfig.order : null,
      filteredValue: columnFilters.status
        ? columnFilters.status
        : null,
      ...getStatusFilterProps(),
      render: (_, record) => {
        const status = getStatusFromUpdatedData(record?.items || []);
        return (
          <Tooltip title={status}>
            <div>{renderStatusColor(record)}</div>
          </Tooltip>
        );
      },
      sorter: (a, b) => {
        const statusA = getStatusFromUpdatedData(a?.items || []);
        const statusB = getStatusFromUpdatedData(b?.items || []);

        const statusWeightDiff =
          getStatusSortWeight(statusA) - getStatusSortWeight(statusB);

        if (statusWeightDiff !== 0) {
          return statusWeightDiff;
        }

        return statusA.localeCompare(statusB);
      },
    },
    {
      title: 'Ações',
      width: '10%',
      // dataIndex: 'data',
      key: 'action',
          render: (_, record) => (
              <Space size="middle">
                {
                  user?.permissoes?.payment?.isEdit || user?.permissoes?.payment?.editar ? (
                    <EditOutlinedIcon style={{ color: '#1a73e8', cursor: 'pointer' }} onClick={() => handleEditClick(record, view)} />
                  )
                  :
                  (
                    <VisibilityIcon style={{ color: '#1a73e8', cursor: 'pointer' }} onClick={() => handleEditClick(record, view)} />
                  )
                }
                {
                  user?.permissoes?.payment?.isDelete || user?.permissoes?.payment?.excluir ? (
                    <Link to={'#'}>
                      <DeleteOutlinedIcon onClick={(e) => deleteEmb(record)} color='error'/>
                    </Link>
                  )
                  :
                  (
                    ""
                  )
                }
              </Space>
          ),
    },
  ];

    const onClose = () => {
        setOpen(false)
    }

  return(
      <>
        <DialogConfirme 
            open={openDialogYesOrNo} 
            handleClose={handleDialogCloseYesOrNo}
            input={recordInput}
            handleOk={deleteOcorrence}
            title={titleDialogYesOrNo}
            message={messageDialogYesOrNo} 
            status={statusDialogYesOrNo}
          />

        <ModalFilter 
          visible={openModalFilter} 
          onClose={() => setOpenModalFilter(false)} 
          onApply={handleApplyCustomFilter}
          availableColumns={paymentModalFilterColumns}
          selectOptionsMap={{ status: paymentStatusOptions }}
          storageKeySuffix="paymentCustomFilters"
        />

        <DialogSave 
            open={openDialog} 
            handleClose={handleDialogClose}
            title={titleDialog}
            message={messageDialog} 
            status={statusDialog}
        />

        <PaymentModal view={view} visible={open} onClose={onClose} driverName={selectDriver} type={"Adiantamento"} />

        <Table
          columns={columns}
          dataSource={updatedData}
          loading={loading}
          onChange={(_, filters, sorter) => {
            const nextFilters = { ...(filters || {}) };
            delete nextFilters.dateFirstDelivery;
            setColumnFilters(nextFilters);

            if (!sorter || Array.isArray(sorter)) {
              setSorterConfig({ columnKey: null, order: null });
              return;
            }

            setSorterConfig({
              columnKey: sorter.columnKey || sorter.field || null,
              order: sorter.order || null,
            });
          }}
        />

      </>
  ) 

};
export default DataPaymentTableGeral;